import React, { useEffect, useState } from 'react'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './AlterarIdentificadorDelivery.css'
import { PageHeader, Btn, SelectEmpresas, InputText, TextBtn, CustomRadioButton } from '../../../../components'
import {
  getDeliveryByIdentifierLike,
  getDeliveryByInvoiceNumberLike,
  updateMultiplesDeliveries,
} from '../../../../services/api/https/deliveries/delivery.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'

const SEARCHTYPES = [
  { label: 'Identificador', value: 'id' },
  { label: 'N° NF', value: 'nf' },
]

const INITIAL_STATE = {
  company_id: '',
  selectedEmpresa: null,
  selectedSearchType: 'id',
  searchText: '',
  deliveries: [],
  errorMessage: '',
  loadingMessage: null
}

function AlterarIdentificadorDelivery({ selectedTp, dispatch, history }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    dispatch(showMessageBox(null, state.errorMessage))
  }, [state.errorMessage])

  useEffect(() => {
    if (state.loadingMessage) dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    else dispatch(hideLoadingBox())
  }, [state.loadingMessage])

  const onEmpresaChange = value => {
    setState(prevState => ({ ...prevState, company_id: value.id }))
  }

  const onSearchTypeChange = value => {
    setState(prevState => ({ ...prevState, selectedSearchType: value }))
  }

  const onSearchTextChange = value => {
    setState(prevState => ({ ...prevState, searchText: value }))
  }

  const searchDeliveries = (searchText, selectedSearchType, company_id) => {
    if (company_id === '')
      dispatch(showMessageBox(null, 'Selecione uma empresa antes de tentar efetuar a busca', null))
    else if (searchText.trim() === '') {
      if (selectedSearchType === 'id')
        dispatch(showMessageBox(null, 'Insira um identificador válido para pesquisar'))
      else
        dispatch(showMessageBox(null, 'Insira um n° de NF válido para pesquisar'))
    } else {
      setState(prevState => ({ ...prevState, loadingMessage: 'Carregando' }))
      if (selectedSearchType === 'id') {
        getDeliveryByIdentifierLike(company_id, searchText)
          .then(res => {
            res.forEach(r => {
              r.novoIdentificador = r.identifier
              r.novoNumeroNF = r.invoice_number
            })
            setState(prevState => ({ ...prevState, deliveries: res }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: err, deliveries: [] })))
          .finally(() => setState(prevState => ({ ...prevState, loadingMessage: null })))
      } else {
        getDeliveryByInvoiceNumberLike(company_id, searchText)
          .then(res => {
            res.forEach(r => {
              r.novoIdentificador = r.identifier
              r.novoNumeroNF = r.invoice_number
            })
            setState(prevState => ({ ...prevState, deliveries: res }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: err, deliveries: [] })))
          .finally(() => setState(prevState => ({ ...prevState, loadingMessage: null })))
      }
    }
  }

  const onNovoIdentificadorChange = (delivery, value) => {
    setState(prevState => {
      const index = prevState.deliveries.findIndex(d => d.id === delivery.id)
      if (index !== -1) {
        prevState.deliveries[index].novoIdentificador = value
      }
      return { ...prevState }
    })
  }
  const onNovoNumeroNFChange = (delivery, value) => {
    setState(prevState => {
      const index = prevState.deliveries.findIndex(d => d.id === delivery.id)
      if (index !== -1) {
        prevState.deliveries[index].novoNumeroNF = value
      }
      return { ...prevState }
    })
  }

  const salvarIdentificadores = async (deliveries, selectedTp) => {

    const deliveriesWithNewIdentifiers = deliveries.filter(
      d => {
        const hasIdentifierChanged = d.novoIdentificador !== d.identifier && d.novoIdentificador.trim() !== '';

        if (d.invoice_number && d.invoice_number.trim() !== '') {
          const hasInvoiceNumberChanged = d.invoice_number !== d.novoNumeroNF && d.novoNumeroNF.trim() !== '';
          return hasIdentifierChanged && hasInvoiceNumberChanged;
        }

        return hasIdentifierChanged;
      },
    )

    if (!deliveriesWithNewIdentifiers.length) {
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Insira um identificador ou identificador e n° NF válido',
        loadingMessage: null,
      }))
      return
    }

    if (!selectedTp) {
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Selecione um TP',
        loadingMessage: null,
      }))
      return
    }

    setState(prevState => ({ ...prevState, loadingMessage: 'Alterando Identificadores ou Identificadores e Nº NF' }))

    const deliveriesToSave = []
    for (let deliveryWithNewIdentifier of deliveriesWithNewIdentifiers) {
      const { novoIdentificador, novoNumeroNF, nome_fantasia, created_at, updated_at, ...delivery } =
        deliveryWithNewIdentifier

      delivery.identifier = novoIdentificador
      delivery.invoice_number = novoNumeroNF

      deliveriesToSave.push(delivery)
    }

    await updateMultiplesDeliveries(deliveriesToSave, selectedTp)
      .then(() => {
        dispatch(showMessageBox('Novos identificadores salvos com sucesso', null))
        setState(prevState => ({ ...prevState, deliveries: [] }))
      })
      .catch(err =>
        setState(prevState => ({ ...prevState, errorMessage: err })),
      )
      .finally(() => setState(prevState => ({ ...prevState, loadingMessage: null })))

  }

  const onBtnVoltarClicked = () => {
    history.goBack()
  }

  return (
    <div>
      <PageHeader>
        <span>S.18 - Alterar Codigo do Identificador da Delivery</span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel>
          <div className="p-grid p-align-end">
            <div className="p-col-3">
              <SelectEmpresas
                companyId={state.company_id}
                onChange={value => onEmpresaChange(value)}
              />
            </div>
            <div className="p-col-3">
              <div style={{ marginLeft: -10 }}>
                <CustomRadioButton
                  items={SEARCHTYPES}
                  value={state.selectedSearchType}
                  onChange={value => onSearchTypeChange(value)}
                  labelColor="#14B0BF"
                  labelFontSize="0.8rem"
                />
              </div>
              <InputText label={''} onChange={value => onSearchTextChange(value)} marginTop={0} />
            </div>
            <div className="p-col-fixed" style={{ width: 'fit-content' }}>
              <Btn onClick={() => searchDeliveries(state.searchText, state.selectedSearchType, state.company_id)}>
                Pesquisar
              </Btn>
            </div>
            <div className="p-col-fixed" style={{ width: 'fit-content' }}>
              <Btn onClick={() => salvarIdentificadores(state.deliveries, selectedTp)}>
                Salvar Identificadores
              </Btn>
            </div>
            <div className="p-col">
              <TextBtn onClick={onBtnVoltarClicked}>Voltar</TextBtn>
            </div>
          </div>
          <div className="p-grid p-col-12" style={{ marginTop: 10 }}>
            <DataTable value={state.deliveries} emptyMessage="Nenhuma entrega para exibir">
              <Column field="nome_fantasia" header="Empresa" style={tableCellCentered()} />
              <Column field="identifier" header="Identificador" style={tableCellCentered()} />
              <Column field="invoice_number" header="N° NF" style={tableCellCentered()} />
              <Column field="qteSkuTotal" header="Qte. Caixas" style={tableCellCentered()} />
              <Column
                field="novo_identifier"
                header="Novo Identificador"
                style={tableCellCentered()}
                body={delivery => (
                  <InputText
                    value={delivery.novoIdentificador}
                    onChange={value => onNovoIdentificadorChange(delivery, value)}
                  />
                )}
              />
              <Column
                field="novo_invoice_number"
                header="Novo N° NF"
                style={tableCellCentered()}
                body={delivery => (
                  <InputText
                    value={delivery.novoNumeroNF}
                    onChange={value => onNovoNumeroNFChange(delivery, value)}
                  />
                )}
              />
            </DataTable>
          </div>
        </Panel>
      </div >
    </div >
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AlterarIdentificadorDelivery))
